/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import UsersService from "@velocity-ehs/user-utils-module";
import { useTranslation } from "react-i18next";

import classes from "./UserProfileMenu.module.scss";
import LinkList from "../../sharedComponents/LinkList";

const UserProfileMenu: React.FC = () => {
  const { t } = useTranslation();
  const { user } = UsersService;
  const history = useHistory();
  const location = useLocation();
  const [userMenuItems, setUserMenuItems] = useState<any[]>([]);

  const getUserMenu = () => {
    let items: any[] = [];
    if (user && (user.firstName || user.lastName)) {
      items = user.isSso
        ? [
            {
              label: t("profile_My_Profile_Tab"),
              url: `/profile`,
              selected: isSelected(),
            },
          ]
        : [
            {
              label: t("profile_My_Profile_Tab"),
              selected: isSelected(),
              command: () => {
                history.push(`/profile`);
              },
            },
            {
              label: t("universal_Logout"),
              command: () => UsersService.logout(),
            },
          ];
    }

    return items;
  };

  const isSelected = () => {
    if (!user) return false;
    return location.pathname.startsWith(`/profile`);
  };

  useEffect(() => {
    setUserMenuItems(getUserMenu());
    // eslint-disable-next-line
  }, [location]);

  return (
    <>
      <div className={classes.userNameContainer}>
        <span>{user?.firstName}</span>
        <span>{user?.lastName}</span>
      </div>
      <LinkList items={userMenuItems} />
    </>
  );
};

export default UserProfileMenu;
